// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__LFbN1","log":"ModalInventoryLogs_log__22y1J","date":"ModalInventoryLogs_date__22vIa","userName":"ModalInventoryLogs_userName__Ly1gB"};